import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';
import { getFormErrorsFromResponse } from '@app/services/getFormErrorsFromResponse';

interface IParams {
  order_uid: string;
  status_uid: string;
  version: string;
}

export const useMoveToStatusQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);
  const validationT = useTranslation(NSKeys.validation);

  return useMutation({
    mutationFn: async ({ order_uid, status_uid, version }: IParams) => {
      await Api.orders.postMoveToStatus(order_uid, status_uid, version);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      client.invalidateQueries(['getOrdersByProcess']);
      client.invalidateQueries(['getOrders']);
      client.invalidateQueries(['getOrder']);
    },
    onError: (err) => {
      client.invalidateQueries(['getOrdersByProcess']);
      const { formMessages } = getFormErrorsFromResponse({}, err, validationT.t);
      message.open({
        type: 'error',
        content: formMessages[0] || commonT.t('error400'),
      });
    },
  });
};
